import * as _ from 'lodash';
import { Observable, generate } from 'rxjs';
import * as XLSX from 'xlsx';
import moment from 'moment';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import * as FileSaver from 'file-saver';

declare const ExcelJS: any;

export function JSONToExcelV2(json, headersMap, booleanMap, sheetName, fileName) {
    const workbook: ExcelJS.Workbook = new ExcelJS.Workbook();
    workbook.creator = 'Me';
    workbook.lastModifiedBy = 'Her';
    workbook.created = new Date(1985, 8, 30);
    workbook.modified = new Date();
    workbook.lastPrinted = new Date(2016, 9, 27);
    workbook.properties.date1904 = true;

    const worksheet: ExcelJS.WorkSheet = workbook.addWorksheet(sheetName, { properties: { tabColor: { argb: 'FFC0000' } } });
    const jsonMapped = JSONExcelMapping(json, headersMap, booleanMap);
    const columns = [];
    //Add columns and header    
    _.forEach(_.keys(headersMap), (header: any) => {
        if (_.isArray(headersMap[header])) {
            _.forEach(headersMap[header], (headerMap) => {
                const field = headerMap.field ? '-' + headerMap.field : ''
                const combineHeader = header + field;
                columns.push({ header: headerMap.column, key: combineHeader, hidden: headerMap.hidden ? headerMap.hidden : false });
            });
        }
        else {
            const field = headersMap[header].field ? '-' + headersMap[header].field : ''
            const combineHeader = header + field;
            columns.push({ header: headersMap[header].column, key: combineHeader, hidden: headersMap[header].hidden ? headersMap[header].hidden : false });
        }
    });
    worksheet.columns = columns;
    //worksheet.protect('123456');
    /** Add rows */
    worksheet.addRows(jsonMapped);
    const row = worksheet.getRow(1);
    row.eachCell(function (cell) {

        /** Header style */
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
                argb: 'FFd63342'
            }
        };
        cell.font = {};
        cell.font.size = 12;
        cell.font.color = { argb: 'FFFFFF' };
        cell.alignment = { vertical: 'middle', horizontal: 'left' };
        cell.protection = {
            locked: true
        }
    });

    /** Set Properties to data cells */
    for (let index = 2; index < jsonMapped.length + 2; index++) {
        const row = worksheet.getRow(index);
        row.eachCell(function (cell) {
            cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
            if (_.includes(cell.value, 'base64')) {
                const imageId2 = workbook.addImage({
                    base64: cell.value,
                    extension: 'png',
                });

                worksheet.addImage(imageId2, {
                    tl: { col: cell.col - 1, row: cell.row - 1 }
                    //,ext: { width: 500, height: 200 }
                    , br: { col: cell.col, row: cell.row }
                });

            }
            if (typeof cell.value === 'string' && cell.value.includes('<')) {
                const rich = htmlToRichText(cell.value);
                if (rich.length > 0) {
                    cell.value = { richText: rich };
                }
            }
        });
    }


    /** Autosize column width */
    autoSize(worksheet, 0);

    workbook.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        FileSaver.saveAs(blob, fileName);
    });
}

export function JSONToExcelMultiple(sheets, booleanMap, fileName) {
    const workbook: ExcelJS.Workbook = new ExcelJS.Workbook();
    workbook.creator = 'Me';
    workbook.lastModifiedBy = 'Her';
    workbook.created = new Date(1985, 8, 30);
    workbook.modified = new Date();
    workbook.lastPrinted = new Date(2016, 9, 27);
    workbook.properties.date1904 = true;

    _.forEach(sheets, (sheet: any) => {

        const worksheet: ExcelJS.WorkSheet = workbook.addWorksheet(sheet.sheetName, { properties: { tabColor: { argb: 'FFC0000' } } });
        const jsonMapped = JSONExcelMapping(sheet.json, sheet.headersMap, booleanMap);

        const columns = [];
        //Add columns and header    
        _.forEach(_.keys(sheet.headersMap), (header: any) => {
            if (_.isArray(sheet.headersMap[header])) {
                _.forEach(sheet.headersMap[header], (headerMap) => {
                    const field = headerMap.field ? '-' + headerMap.field : ''
                    const combineHeader = header + field;
                    columns.push({ header: headerMap.column, key: combineHeader, hidden: headerMap.hidden ? headerMap.hidden : false });
                });
            }
            else {
                const field = sheet.headersMap[header].field ? '-' + sheet.headersMap[header].field : ''
                const combineHeader = header + field;
                columns.push({ header: sheet.headersMap[header].column, key: combineHeader, hidden: sheet.headersMap[header].hidden ? sheet.headersMap[header].hidden : false });
            }
        });

        worksheet.columns = columns;
        //worksheet.protect('123456');
        /** Add rows */
        worksheet.addRows(jsonMapped);
        const row = worksheet.getRow(1);

        row.eachCell(function (cell) {

            /** Header style */
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {
                    argb: 'FFd63342'
                }
            };
            cell.font = {};
            cell.font.size = 14;
            cell.font.color = { argb: 'FFFFFF' };
            cell.alignment = { vertical: 'middle', horizontal: 'left' };
            cell.protection = {
                locked: true
            }
        });

        /** Set Properties to data cells */
        for (let index = 2; index < jsonMapped.length + 2; index++) {
            const row = worksheet.getRow(index);
            row.eachCell(function (cell) {
                cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
            });
        }
        /** Autosize column width */
        autoSize(worksheet, 0);
    })

    workbook.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        FileSaver.saveAs(blob, fileName);
    });
}

export function ExcelToJSONV2(excelBinaryString, headersMap, booleanMap): Promise<any> {
    const workbook = new ExcelJS.Workbook();
    return new Promise<any>((resolve, reject) => {
        workbook.xlsx.load(excelBinaryString)
            .then(() => {
                let json = [];
                let header;
                let parameters: any = generateHeader(headersMap);
                workbook.eachSheet(function (worksheet, sheetId) {
                    worksheet.eachRow(function (row, rowNumber) {
                        if (rowNumber === 1) {
                            header = row.values;
                        }
                        else {
                            const obj = {};
                            const rowData = row.values;
                            for (let colNumber = 1; colNumber < rowData.length; colNumber++) {
                                const cell = !_.isUndefined(rowData[colNumber]) ? rowData[colNumber] : null;
                                const col = header[colNumber] ? header[colNumber] : null;
                                if (col && parameters[col]) {
                                    if (_.isObject(parameters[col])) {
                                        const subKey = _.keysIn(parameters[col])[0];
                                        if (!obj[subKey]) {
                                            _.assign(obj, { [subKey]: { [parameters[col][subKey]]: cell } });
                                        }
                                        else {
                                            obj[subKey][parameters[col][subKey]] = cell;
                                        }
                                    }
                                    else {
                                        _.set(obj, parameters[col], cell);
                                    }
                                }
                            }
                            json.push(obj);
                        }
                    });
                });
                resolve(json);
            });
    });
}
export function normalizeCaseAndAccents(str) {
    if (str) {
        return str.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }
    return str;
}
export function fileToBase64(file, keepDataType?: boolean) {
    return new Observable((observer) => {
        const reader = new FileReader();
        reader.readAsDataURL(file)

        reader.onload = () => {
            let encoded = reader.result.toString();
            if (!keepDataType) {
                encoded = encoded.replace(/^data:(.*,)?/, '');
                if ((encoded.length % 4) > 0) {
                    encoded += '='.repeat(4 - (encoded.length % 4));
                }
            }
            observer.next(encoded)
        }
    })
}

export function JSONToExcel(json, headersMap, booleanMap, sheetName, fileName) {
    let jsonMapped = JSONExcelMapping(json, headersMap, booleanMap);
    let columnsWidth = calculateColumnsWidth(jsonMapped);
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonMapped);
    ws["!cols"] = columnsWidth;
    setHeadersBold(ws);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    /* save to file */
    XLSX.writeFile(wb, fileName);
}
export function excelToJSON(excelBinaryString, headersMap, booleanMap) {
    const wb: XLSX.WorkBook = XLSX.read(excelBinaryString, { type: 'binary' });

    /* grab first sheet */
    const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];

    /* save data */
    let data = XLSX.utils.sheet_to_json(ws, { header: 1 });

    data = AOAtoJSON(data);
    data = excelJSONMapping(data, headersMap, booleanMap);


    return data;
}

export function generateHeader(headersMap) {
    const obj = {};
    let keys = _.keys(headersMap);
    _.forEach(keys, (i) => {
        if (_.isArray(headersMap[i])) {
            _.forEach(headersMap[i], (headerMap) => {
                _.assign(obj, { [headerMap.column]: headerMap.field ? { [i]: headerMap.field } : i });
            });
        }
        else {
            _.assign(obj, { [headersMap[i].column]: headersMap[i].field ? { [i]: headersMap[i].field } : i });
        }

    });

    return obj;
}

export function JSONExcelMapping(json, headersMap, booleanMap) {
    let keys = _.keys(headersMap);
    return _.map(json, (i) => {
        let itemMapped = {}
        _.forEach(keys, (k) => {
            let value = _.get(i, k);
            if (_.isBoolean(value) || _.includes(_.keys(booleanMap), value)) {
                setDataMapped(_.get(booleanMap, value.toString()), headersMap[k], itemMapped, k);
            }
            else if (_.isArray(headersMap[k])) {
                _.forEach(headersMap[k], (header) => {
                    setDataMapped(value, header, itemMapped, k, booleanMap) // 
                });
            }
            else {
                setDataMapped(value, headersMap[k], itemMapped, k);
            }

        })
        return itemMapped;
    })
}

export function setDataMapped(value, header, itemMapped, k, booleanMap = null) {
    const field = header.field ? '-' + header.field : '';
    const combineHeader = k + field;
    if (_.isArray(value)) {
        let concat = [];
        value.forEach((element, index) => {
            const i = header.field ? header.field : null;
            let item = i ? _.get(element, i) : element;
            if (_.isDate(item)) {
                item = moment(item).format('DD/MM/YYYY');
            } else if (_.isBoolean(item) && booleanMap) { // mejora/trabajo-previsto  añadido if para controlar si es booleano o no el elemento (item) que recibe
                item = _.get(booleanMap, item.toString())
            }
            concat.push(item);
        });
        _.set(itemMapped, combineHeader, concat.join('\r\n'));
    }
    else if (!_.isArray(value) && _.isObject(value)) {
        const obj = value[header.field];
        _.set(itemMapped, combineHeader, obj);
    }
    else {
        _.set(itemMapped, combineHeader, value);
    }
}

export function excelJSONMapping(json, headersMap, booleanMap) {
    let swappedHeadersMap = {}
    _.forIn(headersMap, (value, key) => {
        swappedHeadersMap[value] = key;
    })
    let swappedBooleanMap = {}
    _.forIn(booleanMap, (value, key) => {
        swappedBooleanMap[value] = key === 'true' ? _.stubTrue() : _.stubFalse();
    })
    return JSONExcelMapping(json, swappedHeadersMap, swappedBooleanMap);
}
export function calculateColumnsWidth(items) {
    let maxWidths = []
    _.forEach(items, (i) => {
        let columns = _.valuesIn(i);
        _.forEach(columns, (c, index) => {
            let currentWidth = _.get(maxWidths[index], 'width') || 0;
            let newWidth = _.get(c, 'length') || 0;
            let widthObject = {
                width: newWidth >= currentWidth
                    ? newWidth : currentWidth
            }
            maxWidths[index] = widthObject;
        })
    })
    return maxWidths
}
export function setHeadersBold(worksheet) {
    _.forIn(worksheet, (value, cellName) => {
        if (cellName.length === 2 && _.last(cellName) === '1') {
            value.s = { font: { bold: true } }
        }
    })
    return worksheet;
}
export function AOAtoJSON(json) {
    let keys = json.shift()
    let jsonArray = _.map(json, (item) => {
        let newItem = {}
        _.forEach(item, (value, index) => {
            newItem[keys[index]] = value;
        })
        return newItem;
    })
    return jsonArray;
}
export function autoSize(sheet: ExcelJS.Worksheet, fromRow: number) {
    const PIXELS_PER_EXCEL_WIDTH_UNIT = 7.5;
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) {
        return
    }

    const maxColumnLengths: Array<number> = []
    sheet.eachRow((row, rowNum) => {
        if (rowNum < fromRow) {
            return
        }
        let hasImg = false;
        row.eachCell((cell, num) => {
            if (typeof cell.value === 'string') {
                if (maxColumnLengths[num] === undefined) {
                    maxColumnLengths[num] = 0
                }

                const fontSize = cell.font && cell.font.size ? cell.font.size : 11
                ctx.font = `${fontSize}pt Arial`
                const metrics = ctx.measureText(cell.value)
                let cellWidth = metrics.width
                if (_.includes(cell.value, 'base64')) {
                    cellWidth = 350;
                    cell.value = '';
                    hasImg = true;
                }
                maxColumnLengths[num] = Math.max(maxColumnLengths[num], cellWidth)
            }
        })
        if (hasImg) {
            row.height = 100;
        }
    })

    for (let i = 1; i <= sheet.columnCount; i++) {
        const col = sheet.getColumn(i)
        const width = maxColumnLengths[i]
        if (width) {
            col.width = width / PIXELS_PER_EXCEL_WIDTH_UNIT + 1
        }
    }

}

function htmlToRichText(html: string): ExcelJS.CellRichText[] {
    const tagStack: Partial<ExcelJS.Font>[] = [];
    const result: ExcelJS.CellRichText[] = [];

    let buffer = '';
    let i = 0;

    const pushBuffer = () => {
        if (buffer) {
            const font = Object.assign({}, ...tagStack);
            result.push({ text: buffer, font });
            buffer = '';
        }
    };

    while (i < html.length) {
        if (html[i] === '<') {
            const endTag = html.indexOf('>', i);
            if (endTag === -1) break;

            const tagContent = html.slice(i + 1, endTag).trim().toLowerCase();
            const isClosing = tagContent.startsWith('/');

            const tag = isClosing ? tagContent.slice(1) : tagContent;

            pushBuffer();

            if (!isClosing) {
                const font: Partial<ExcelJS.Font> = {};
                if (tag === 'b' || tag === 'strong') {
                    font.bold = true;
                } else if (tag === 'i' || tag === 'em') {
                    font.italic = true
                } else if (tag === 'u') {
                    font.underline = true;
                } else if (tag === 'br') {
                    result.push({ text: '\n' });
                    i = endTag + 1;
                    continue;
                } else if (tag === 'li') {
                    result.push({ text: '\n -' });
                    i = endTag + 1;
                    continue;
                }
                tagStack.push(font);
            } else {
                tagStack.pop();
            }

            i = endTag + 1;
        } else {
            buffer += html[i];
            i++;
        }
    }

    pushBuffer();
    return result;
}